import {
  addDays,
  endOfISOWeek,
  endOfMonth,
  format,
  isAfter,
  isBefore,
  startOfDay,
  startOfISOWeek,
} from 'date-fns';
import { dbDayDateToken } from 'server/static/dbDayDateToken';

export class AvailabilityWeek {
  public days: Array<{ utcDate: Date; dateString: string }> = [];
  public startDateString: string;
  public startDate: Date;
  public weekStartDate: Date;
  public weekEndDate: Date;
  public endDate: Date;

  private iStartDate: Date;

  constructor(
    iStartDate: Date,
    earlyEndDate?: Date,
    breakFrom?: Date,
    breakTo?: Date,
  ) {
    this.iStartDate = iStartDate;
    this.startDate = startOfDay(iStartDate);
    this.startDateString = format(iStartDate, dbDayDateToken);
    this.weekStartDate = startOfISOWeek(iStartDate);
    this.weekEndDate = endOfISOWeek(iStartDate);

    const endOfWeekDate = startOfDay(endOfISOWeek(iStartDate));
    const endOfMonthDate = startOfDay(endOfMonth(iStartDate));

    if (isAfter(endOfWeekDate, endOfMonthDate)) {
      this.endDate = endOfMonthDate;
    } else {
      this.endDate = endOfWeekDate;
    }

    if (earlyEndDate && isBefore(earlyEndDate, this.endDate)) {
      this.endDate = earlyEndDate;
    }

    let currentDayStart = new Date(this.startDate);
    const endDate = addDays(this.endDate, 1);
    while (isBefore(currentDayStart, endDate)) {
      if (
        !breakFrom ||
        !breakTo ||
        isBefore(currentDayStart, breakFrom) ||
        isAfter(currentDayStart, breakTo)
      ) {
        this.days.push({
          utcDate: currentDayStart,
          dateString: format(currentDayStart, dbDayDateToken),
        });
      }
      currentDayStart = addDays(currentDayStart, 1);
    }
  }
}
